<template>
  <el-dialog
    :visible.sync="visible"
    :title="dialogTitle"
    width="360px"
    top="12vh"
    append-to-body
    custom-class="share-applicant-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div v-loading="loading" class="applicant-wrap">
      <el-table
        :data="applicantRows"
        :show-header="applicantRows.length > 0"
        :header-cell-style="tableHeaderStyle"
        empty-text="暂无报名名单"
      >
        <el-table-column prop="name" label="姓名" align="center" min-width="110" />
        <el-table-column prop="phone" label="手机号" align="center" min-width="150" />
      </el-table>

      <el-pagination
        v-if="paging.total > 0"
        class="share-pagination"
        background
        small
        :current-page.sync="paging.current_page"
        :page-size="paging.page_size"
        :total="paging.total"
        layout="total, prev, pager, next"
        @current-change="handlePageChange"
      />
    </div>
  </el-dialog>
</template>

<script>
const getFirstValue = (row, keys, fallback = "") => {
  for (let i = 0; i < keys.length; i += 1) {
    const value = row && row[keys[i]];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }
  return fallback;
};

const normalizeList = (response) => {
  if (Array.isArray(response)) return response;
  const source =
    response && response.data && !Array.isArray(response.data)
      ? response.data
      : response;
  if (!source) return [];
  if (Array.isArray(source)) return source;
  if (Array.isArray(source.data)) return source.data;
  if (Array.isArray(source.list)) return source.list;
  if (Array.isArray(source.records)) return source.records;
  if (Array.isArray(source.rows)) return source.rows;
  return [];
};

const normalizePages = (response, fallback) => {
  const source =
    response && response.data && !Array.isArray(response.data)
      ? response.data
      : response;
  const pages = source && source.pages ? source.pages : {};
  return {
    current_page: Number(pages.current_page || fallback.current_page || 1),
    page_size: Number(pages.page_size || fallback.page_size || 10),
    total: Number(pages.total || 0),
  };
};

const getDefaultPaging = () => ({
  current_page: 1,
  page_size: 10,
  total: 0,
});

export default {
  name: "RecruitShareApplicantDialog",
  data() {
    return {
      visible: false,
      loading: false,
      currentPost: {},
      currentShare: {},
      applicantRows: [],
      paging: getDefaultPaging(),
      tableHeaderStyle: {
        background: "#f8fafc",
        color: "#4b5563",
        fontWeight: 600,
      },
    };
  },
  computed: {
    dialogTitle() {
      const name =
        this.currentShare.share_user_name ||
        this.currentShare.user_name ||
        this.currentShare.name ||
        "分享人";
      return `分享人：${name}`;
    },
  },
  methods: {
    async open({ post, share }) {
      if (!post || !post.id || !share || !share.task_share_id) {
        this.$message.warning("未获取到分享记录信息");
        return;
      }
      this.visible = true;
      this.currentPost = post;
      this.currentShare = share;
      this.applicantRows = [];
      this.paging = getDefaultPaging();
      await this.loadApplicantRows();
    },
    async loadApplicantRows() {
      if (!this.currentPost.id || !this.currentShare.task_share_id) return;
      this.loading = true;
      try {
        const response = await this.$api.recruitTaskShareApplyList({
          task_id: this.currentPost.id,
          task_share_id: this.currentShare.task_share_id,
          current_page: this.paging.current_page,
          page_size: this.paging.page_size,
        });
        this.applicantRows = normalizeList(response).map(this.normalizeApplicantRow);
        this.paging = normalizePages(response, this.paging);
      } catch (error) {
        this.$message.error("获取报名名单失败");
      } finally {
        this.loading = false;
      }
    },
    normalizeApplicantRow(row) {
      return {
        ...row,
        name: getFirstValue(row, [
          "name",
          "fullName",
          "realname",
          "user_name",
          "nickname",
        ], "—"),
        phone: getFirstValue(row, ["phone", "mobile", "tel", "contact"], "—"),
      };
    },
    handlePageChange(page) {
      this.paging.current_page = page;
      this.loadApplicantRows();
    },
    handleClose() {
      this.visible = false;
      this.loading = false;
      this.currentPost = {};
      this.currentShare = {};
      this.applicantRows = [];
      this.paging = getDefaultPaging();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .share-applicant-dialog {
  border-radius: 20px;
  overflow: hidden;
}

/deep/ .share-applicant-dialog .el-dialog__header {
  padding: 22px 24px 10px;
}

/deep/ .share-applicant-dialog .el-dialog__title {
  color: #1f2937;
  font-size: 18px;
  font-weight: 700;
}

/deep/ .share-applicant-dialog .el-dialog__body {
  padding: 0 24px 24px;
}

.applicant-wrap {
  min-height: 220px;
  border: 1px solid #edf1f7;
  border-radius: 14px;
  overflow: hidden;
}

.share-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
